<template>
  <div class="supplierMag">
    <el-container>
      <el-header>
        <!-- <div style="width: 100%;background: #D5E7ED;">
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick" style="width: 100%">
            <el-tab-pane label="全部" name="first"></el-tab-pane>
            <el-tab-pane label="待审核" name="second"></el-tab-pane>
            <el-tab-pane label="已通过" name="third"></el-tab-pane>
            <el-tab-pane label="已驳回" name="fourth"></el-tab-pane>
          </el-tabs>
        </div>-->
        <el-form ref="form" :model="Contractform" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="公司名称" label-width="120px">
                <el-input
                  v-model="Contractform.companyName"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="法人姓名" label-width="120px">
                <el-input
                  v-model="Contractform.legalPerson"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="法人电话" label-width="120px">
                <el-input
                  v-model="Contractform.workPhone"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="联系人" label-width="120px">
                  <el-input
                    v-model="Contractform.contactName"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系人电话" label-width="120px">
                  <el-input
                    v-model="Contractform.contactPhone"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合作单位状态" label-width="120px">
                  <el-select
                    v-model="Contractform.status"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="已启用" value="1"></el-option>
                    <el-option label="已停用" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核状态" label-width="120px">
                  <el-select
                    v-model="Contractform.approveStatus"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="已保存" value="0"></el-option>
                    <el-option label="已撤回" value="1"></el-option>
                    <el-option label="待审批" value="2"></el-option>
                    <el-option label="已通过" value="3"></el-option>
                    <el-option label="已拒绝" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 6 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="clearSearchConditions"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              v-if="btnAuthorize.approve.btnEnable"
              icon="el-icon-plus"
              @click="approveSupplierA()"
              >审核</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="SupplierDetail"
          :row-class-name="setRowClassName"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="item.isNumFilter">{{
                scope.row[scope.column.property] | numFilter
              }}</span>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getSupplierAList, //获取供应商列表接口
} from "../../services/supplierMagServices";
import {
  getCurrentApproveListService, //查询当前审批流
} from "@/services/approveServices";
export default {
  name: "supplierMag",

  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      activeName: "first",
      orgId: 0, //存储组织id
      selectItems: [], //记录选中的供应商
      currentUserId: "", //当前登录用户id
      //查询条件form
      Contractform: {
        companyName: "", //公司名称
        contactName: "", //联系人
        contactPhone: "", //联系人电话
        legalPerson: "", //法人
        status: "", //供应商状态
        approveStatus: "", //审核状态
        workPhone: "", //公司电话
      },
      tableColumnDatas: [
        { class: "companyName", labelName: "公司名称", sortEnable: false },
        { class: "typeDisplayName", labelName: "分类", sortEnable: false },
        { class: "legalPerson", labelName: "法人姓名", sortEnable: false },
        {
          class: "workPhone",
          labelName: "办公电话",
          sortEnable: false,
        },
        { class: "contactName", labelName: "联系人姓名", sortEnable: false },
        { class: "contactPhone", labelName: "联系人电话", sortEnable: false },
        { class: "publicBank", labelName: "开户行", sortEnable: false },
        {
          class: "publicBankNumber",
          labelName: "开户行行号",
          sortEnable: false,
        },
        {
          class: "publicCompanyName",
          labelName: "发票抬头",
          sortEnable: false,
        },
        {
          class: "publicTaxAccount",
          labelName: "纳税人识别号",
          sortEnable: false,
        },
        { class: "statusDisName", labelName: "供应商状态", sortEnable: false },
        {
          class: "approveStatusDisName",
          labelName: "供应商审核状态",
          sortEnable: false,
        },
      ],
      showAdvanceFilter: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      approveFlag: true, //审核标记
      tableData: [],
      btnAuthorize: {
        approve: { key: "approve", btnEnable: false },
      },
    };
  },
  mounted() {
    this.currentUserId = sessionStorage.getItem("currentUserId");
    this.orgId = sessionStorage.getItem("orgId");
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    onActive(menuCode) {
      this.currentPage = 1;
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList(); //获取下拉列表  gaa 20200806
    },
    //点击查询
    handleClick() {
      this.currentPage = 1;
      this.initList();
    },
    //获取供应商列表
    initList() {
      let param = {
        // currentUserId: this.currentUserId, // sessionStorage.getItem("userCode"),
        // sort: "name",
        // order: "asc",
        isOnlyApproveCheck: 1, //是否过滤可审核, 1:待审批及审批通过(pc端)
        topType: "bType",
        tabIndex: this.Contractform.tabIndex,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      for (let key in this.Contractform) {
        if (this.Contractform[key] !== "") {
          param[key] = this.Contractform[key];
        }
      }
      if (this.Contractform.signDate && this.Contractform.signDate.length > 1) {
        param.signDateStart = this.Contractform.signDate[0];
        param.signDateEnd = this.Contractform.signDate[1];
        delete param.signDate;
      }
      getSupplierAList(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.dealTableData(res);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    dealTableData(res) {
      this.tableData = res.data;
      this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
      this.totalCount = res.total;
    }, //

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.Contractform) {
        if (key != "tabIndex") {
          this.Contractform[key] = "";
        }
      }
      this.handleClick();
    }, //
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initList();
    },
    //选择一条供应商
    handleSelectionChange(val) {
      this.selectItems = val;
      console.log(val);
    }, //
    setRowClassName({ row, rowIndex }) {
      if (row.isOverTime != 0) {
        return "overTimeMark";
      }
    }, //
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //双击跳转详情
    SupplierDetail(row, column, cell, event) {
      let param = {};
      param.id = row.id;
      param.approveFlag = false; //双击跳转供应商详情
      param.detailFlag = "D"; //详请 false 审核 true
      param.routeId = "supplierAApproveDetail";
      this.bus.$emit("navMenuChange", {
        routeId: "supplierAApproveDetail",
        routeParam: param,
      });
    },
    //查询当前审批流
    getApproveList(id) {
      let param = {
        id: id,
      };
      // param.itemId = this.supplierId; //供应商id
      param.type = "SUPPLIER"; //类型：供应商
      getCurrentApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let memberData = {};
            memberData.approveFlag = 'currentApprove_super'; //审核标志为1
            memberData.id = this.selectItems[0].id; //选中行
            memberData.sort = res.data.sort;
            // memberData.path = "order-list";
            this.bus.$emit("navMenuChange", {
              routeId: "supplierBApprove",
              routeParam: memberData,
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {});
    },

    //跳转到审核甲方信息
    approveSupplierA() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.selectItems[0].approveStatus != 2) {
        this.$alert("只有 待审批 状态的供应商允许审批", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.getApproveList(this.selectItems[0].id);
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
  },
};
</script>

<style scoped >
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.supplierMag {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  // background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
